import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../store/cartSlice";


function ViewDetailsPackageOfFemale({e,setOpenViewDetails } ) {

  const dispatch = useDispatch();



  const handleADD=(e)=>{

    dispatch(addToCart(e))

    setOpenViewDetails(null)
    
  }


  // console.log(e)


  return (
   <div className='view-details-package-OfFemale'>
      <div className='inner-view-details-package-OfFemale'>


        
        <div className='main-views-content-modal-scroll'>




     <div className='inner-main-views-content-modal-scrol'>


       <div>   <button className='View-package-details-close-btn' onClick={()=>setOpenViewDetails(null)}>×</button> </div>

       
                <div className='main-top-view-details-img-content-box'> 
                
                <div className='view-details-package-img-cont'>
                              <img src={e.image}></img>

                </div>

                <div className='view-details-image-shadow-componet'> </div>


                <div className='views-details-top-shaow-text-content'> 
                  {e.fullName}
                  </div>
                  
                  
                  </div>
          
     </div> 
      

{/* :::::::::::::;bOX2:::::::::::::::::::::; */}


<div className='view-details-of-package-second-row'>

  <div className='view-details-show-prices-row'>
     <div className='view-details-show-prices-col1' > 
      <div> ₹ {e.price}</div>
      <div> <span> ₹ {e.mainPrice}</span>  <span> {Math.floor(((e.mainPrice - e.price)/e.mainPrice)*100)}% Off</span> </div>
     </div>
     {/* <div>  <i class="fa-regular fa-clock"></i>
     {e.duration}min 
     </div> */}
  </div>


<div className='view-details-package-book-now-btn' onClick={()=>handleADD(e)} >BOOK NOW</div>


<div className='view-details-package-what-include'>What's Included</div>

<div className='view-details-package-what-include-content'>

  {/* <div className='view-details-package-what-includ-sm-text'> <i class="fa-solid fa-circle-check"></i> Cleanser + Toner + Moisturizer</div>
    <div className='view-details-package-what-includ-sm-text'> <i class="fa-solid fa-circle-check"></i> Cleanser + Toner + Moisturizer</div>

  <div className='view-details-package-what-includ-sm-text'> <i class="fa-solid fa-circle-check"></i> Cleanser + Toner + Moisturizer</div> */}

{/* Default Include Section ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

{e.viewPackage?.[0]?.Include?.[0]?.Default?.map((point, index) => (
  <div key={index} className='view-details-package-what-includ-sm-text'>
    <i className="fa-solid fa-circle-check"></i> {point}
  </div>
))}




{/* Default Service Include ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

 

{e.viewPackage?.[0]?.Include?.[0]?.ServiceInclude?

<p className='view-package-details-service-inc-head'>Services Include</p>

:""
}

 {e.viewPackage?.[0]?.Include?.[0]?.ServiceInclude?.map((point, index)=>(

   <div key={index} className='view-details-package-what-includ-sm-text'>
    <i className="fa-solid fa-circle-check"></i> {point}
  </div>
 ))
}


{/* Default Service advantage ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}


{e.viewPackage?.[0]?.Include?.[1]?.Advantages?

<p className='view-package-details-service-inc-head'>Advantages</p>

:""
}

 {e.viewPackage?.[0]?.Include?.[1]?.Advantages?.map((point, index)=>(

   <div key={index} className='view-details-package-what-includ-sm-text'>
    <i className="fa-solid fa-circle-check"></i> {point}
  </div>
 ))
}



{/* For Show complimentory::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}



{/* {e.viewPackage?.[0]?.Include?.[1]?.Complementary?

<p className='view-package-details-service-inc-head'> Complementary</p>

:""
}

 {e.viewPackage?.[0]?.Include?.[1]?.Complementary?.map((point, index)=>(

   <div key={index} className='view-details-package-what-includ-sm-text'>
    <i className="fa-solid fa-circle-check"></i> {point}
  </div>
 ))
}
 */}




{/* Second Used Brand Row ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

{/* {  e.viewPackage?.[1].UsedBrandrow ?
  <p className='view-package-details-service-inc-head'>Used Brand </p>
  :""
}
{
  e.viewPackage?.[1].UsedBrandrow &&
    e.viewPackage?.[1].UsedBrandrow.map((point , index)=>(
  <div key={index} className='view-details-package-what-includ-sm-text'>
    <i className="fa-solid fa-circle-check"></i> {point}
  </div>
    ))


} */}


</div>

{/* :Show Brand :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

{
  e.viewPackage?.[1].UsedBrand && 

  <div className='view-details-whats-brand-used'>
  <div> Brand Used </div>
  <div>  {e.viewPackage?.[1].UsedBrand.map((p ,i)=>(
    <span>{p}</span>
  )) } </div>
  
</div>
}






<div className='views-details-fixed-guide-lines-row'>



  <div className='views-details-fixed-guide-lines-cols' >
    <img src='https://www.swagmee.com/media/wysiwyg/who-guidelines-followed.png'></img>
    <p>Adherence to WHO Guidelines</p> 
     </div>
  <div className='views-details-fixed-guide-lines-cols' >
    <img src='https://www.swagmee.com/media/wysiwyg/single-use-products.png'></img>
       <p>  Single-Use Equipments</p>
     </div>
  <div className='views-details-fixed-guide-lines-cols' >
    <img src='https://www.swagmee.com/media/wysiwyg/sanitised-tools.png'></img>
    <p>All Tools are Sanitized</p>
     </div>


</div>



</div>





        </div>




      </div>
    </div>
  )
}

export default ViewDetailsPackageOfFemale